import { render, staticRenderFns } from "./PopupNotify.vue?vue&type=template&id=4c5bffc1&"
import script from "./PopupNotify.vue?vue&type=script&lang=js&"
export * from "./PopupNotify.vue?vue&type=script&lang=js&"
import style0 from "./PopupNotify.vue?vue&type=style&index=0&id=4c5bffc1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports